<template>
	<div>
        <skeleton-loading v-if="requestCalls > 0"></skeleton-loading>

		<div v-else>
			<div v-if="checkTask != '' || formType == 'edit' || formType == 'detail' || formType == 'sapSyncTaskEdit' || formType == 'sapSyncTaskEditEquipment'">
                <McrHeader @emitHeader="applyVarMcrType"></McrHeader>
				<br>

				<!-- KONDISI UNTUK MCR FORM REQUEST -->

				<div v-if="formType == 'edit'">
					<h3>{{ tt("mcr_item") }}</h3>
					<McrFormA1 v-if="mcrType == 'A1'" @saveA1="callStatusProcess"></McrFormA1>
					<McrFormA2 v-if="mcrType == 'A2'" @processA2="callStatusProcess"></McrFormA2>
					<McrFormA3 v-if="mcrType == 'A3'" @saveA3="callStatusProcess"></McrFormA3>
					<McrFormA4 v-if="mcrType == 'A4'" @saveA4="callStatusProcess"></McrFormA4>
					<McrFormB1 v-if="mcrType == 'B1'" @saveB1="callStatusProcess"></McrFormB1>
					<McrFormB @changed_plants="onChangedPlants" :formCode="formCode" v-if="mcrType == 'B2' || mcrType == 'B4'" @saveB="callStatusProcess"></McrFormB>
					<McrFormB3 v-if="mcrType == 'B3'" @saveB3="callStatusProcess"></McrFormB3>
					<McrFormB5 v-if="mcrType == 'B5'" @saveB5="callStatusProcess"></McrFormB5>
					<McrFormAbcEvaluation v-if="mcrType == 'C1'"></McrFormAbcEvaluation>
					<McrFormA1 v-if="mcrType == 'A1S'" @saveA1="callStatusProcess" @showShpA1s="formShpModal" @validateEqpMcrWithShpForm="eqpCodeAndCodeFromShpForm" ref="FormA1"></McrFormA1>
					<McrFormB @changed_plants="onChangedPlants" :formCode="formCode" v-if="mcrType == 'B2S'" @saveB="callStatusProcess" @showShpB="formShpModal" @validateEqpMcrWithShpForm="eqpCodeAndCodeFromShpForm" ref="FormB"></McrFormB>
				</div>

				<div v-if="formType == 'sapSyncTaskEditEquipment'">
					<McrEditEquipment :formCode="formCode" @saveB="callStatusProcess"></McrEditEquipment>
				</div>

				<!-- KONDISI UNTUK MCR FORM APPROVAL -->

				<div v-if="formType == 'approval' || formType == 'detail' || formType == 'sapSyncTaskEdit'">
					<McrFormShp v-if="level == 'SHP' && mcrType == 'A2'" ref="shp" @saveShp="callStatusProcess"></McrFormShp>
					<tabs tabNavClasses="nav-fill flex-column flex-sm-row nav-wrapper" tabContentClasses="card shadow" v-if="['A1','A1S','A2','A3'].includes(mcrType)">
						<tab-pane v-if="mcrType == 'A1' || mcrType == 'A1S' || ((level == 'Specification' || level == 'RopMinMax') && mcrType == 'A2') || mcrType == 'A3'">
							<span slot="title">User Request</span>
							<p class="card-body description">
								<McrFormA1 v-if="mcrType == 'A1' || mcrType == 'A1S'"  @saveA1="callStatusProcess" @showShpA1s="formShpModal" @validateEqpMcrWithShpForm="eqpCodeAndCodeFromShpForm" ref="FormA1"></McrFormA1>
								<McrFormA2 v-if="mcrType == 'A2'" @processA2="callStatusProcess"></McrFormA2>
								<McrFormA3 v-if="mcrType == 'A3'" @saveA3="callStatusProcess"></McrFormA3>
							</p>
						</tab-pane>

						<tab-pane v-if="(mcrType == 'A1' || mcrType == 'A1S' || ((level == 'Specification' || level == 'RopMinMax') && mcrType == 'A2') || mcrType == 'A3') && (authUserRole['Cataloguer'] || authUserRole['Senior Cataloguer'] || authUserRole['Manager Cataloguer'] || authUserRole['Master Data PI'] || authUserRole['Administrator'])">
							<span slot="title">Cataloguing Process</span>
							<p class="card-body description">
								<McrFormB @changed_plants="onChangedPlants" :formCode="formCode" ref="FormB" @saveB="callStatusProcess" @saveA="callStatusProcess" @processA2="callStatusProcess" @saveA3="callStatusProcess"  @showShpB="formShpModal" @validateEqpMcrWithShpForm="eqpCodeAndCodeFromShpForm"></McrFormB>
							</p>
						</tab-pane>
					</tabs>

					<div v-if="['A4','B1','B2','B2S','B3','B4','B5','C1'].includes(mcrType)">
						<McrFormA4 v-if="mcrType == 'A4'" @saveA4="callStatusProcess"></McrFormA4>
						<McrFormB1 v-if="mcrType == 'B1'" @saveB1="callStatusProcess"></McrFormB1>
						<McrFormB @changed_plants="onChangedPlants" :formCode="formCode"  v-if="mcrType == 'B2' || mcrType == 'B4'" @saveB="callStatusProcess"></McrFormB>
						<McrFormB3 v-if="mcrType == 'B3'" @saveB3="callStatusProcess"></McrFormB3>
						<McrFormB5 v-if="mcrType == 'B5'" @saveB5="callStatusProcess"></McrFormB5>
						<McrFormAbcEvaluation v-if="mcrType == 'C1'"></McrFormAbcEvaluation>
						<McrFormB @changed_plants="onChangedPlants" :formCode="formCode" v-if="mcrType == 'B2S'" @saveB="callStatusProcess" @showShpB="formShpModal" ref="FormB" @validateEqpMcrWithShpForm="eqpCodeAndCodeFromShpForm"></McrFormB>
					</div>
				</div>

				<McrFooter :plants="plant_data" ref="statusProcess"></McrFooter>

				<!-- MODAL SHP -->
				<modal :show.sync="formShp" size="lg">
					<template slot="header">
						<h5 class="modal-title">{{ tt('stock_holding_policy')}}</h5>
					</template>
					<div>
						<McrFormShp v-if="formType != 'sapSyncTaskEditEquipment'" ref="shp" @saveShp="callStatusProcess" @closeShp="closeSHP"></McrFormShp>
					</div>
					<template slot="footer">
						<base-button type="secondary" @click="formShpModal">{{ tt('close') }}</base-button>
					</template>
				</modal>
			</div>
			<expiredpage v-else/>
		</div>
	</div>
</template>

<script>
	import {mapState} from 'vuex'
	import Api from "@/helpers/api";
	import draftList from "@/services/material/draftList.service";
	import myTaskDashboard from '@/services/dashboard/myTaskDashboard.service';

	// MCR FORM
	import McrHeader from "./McrHeader.vue";
	import McrFooter from "./McrFooter.vue";
	import McrFormA1 from "./McrFormA1.vue";
	import McrFormA2 from "./McrFormA2.vue";
	import McrFormA3 from "./McrFormA3.vue";
	import McrFormA4 from "./McrFormA4.vue";
	import McrFormB1 from "./McrFormB1.vue";
	import McrEditEquipment from "./McrEditEquipment.vue";
	import McrFormB from "./McrFormB.vue";
	import McrFormB3 from "./McrFormB3.vue";
	import McrFormB5 from "./McrFormB5.vue";
	import McrFormAbcEvaluation from "./McrFormAbcEvaluation.vue";
	import McrFormShp from "./McrFormShp.vue";

	export default {
		components: {
	      McrHeader,
	      McrFooter,
		  McrFormA1,
		  McrFormA2,
		  McrFormA3,
		  McrFormA4,
		  McrFormB1,
		  McrEditEquipment,
		  McrFormB,
		  McrFormB3,
		  McrFormB5,
		  McrFormAbcEvaluation,
		  McrFormShp,
	    },
		props:['saveA1', 'processA2','saveA3','saveA4','saveB','saveB1','saveB3','saveB5', 'saveShp', 'showShpA1s','showShpB','closeShp', 'emitHeader', 'validateEqpMcrWithShpForm'],
	    data() {
	    	return {
                requestCalls: 0,
                checkTask: '',
				mcrType: this.$route.params.mcr_type,
	    		mcr_code: this.$route.params.mcr_code,
	    		mcrItemCode: this.$route.params.mcr_item_code,
				formType: this.$route.params.type,
				level: '',
				formShp:false,
				formCode: '',
				plant_data: []
	    	}
	    },
	    computed: {
            ...mapState({
                authUser :state => state.auth.user,
                authUserPermission :state => state.auth.userPermission,
                authUserRole :state => state.auth.userRole
            }),
        },
	    mounted() {
			if (this.formType == 'approval') {
				this.checkTaskTicket();
			}
			this.clientPlantLevel()
		},
		methods: {
			onChangedPlants(values) {
				this.plant_data = values
			},
		    checkTaskTicket() { // untuk cek apakah user login punya task ticket yang bersangkutan
		    	this.requestCalls++;

                let context = this;
                Api(context, myTaskDashboard.check_task_ticket(this.mcr_code)).onSuccess(function(response) {
                    context.checkTask = response.data;
                }).onError(function(error) {
                    context.checkTask = [];
                }).onFinish(function() {
                	context.requestCalls--;
                }).call()
            },
			clientPlantLevel() {
				let context = this;

		      	Api(context, draftList.getDetailMcrItem(this.mcrItemCode))
		        .onSuccess(function(response) {
		            context.level = response.data.data[0].client_plant_level;
		        })
		        .onError(function(error) {
		          if (error.response.status == 404) {
					context.level = ''
				  }
		        }).onFinish(() => {
					context.requestCalls--;
				})
		        .call();
			},
			callStatusProcess(event){
				this.$refs.statusProcess.get();
				if(event === 'shp'){
					if(this.$refs.FormA1){
						this.$refs.FormA1.getDetailMcrItem()
					}
					if(this.$refs.FormB){
						this.$refs.FormB.getDetailMcrItem()
					}
				}
			},
			formShpModal(eqp, code, id, uom_code, price_reference){
				if(eqp){
					this.formShp = !this.formShp
					this.$refs.shp.input.shp_equipment = eqp
					this.$refs.shp.input.shp_uom = uom_code
					this.$refs.shp.input.shp_uom_mirroring = uom_code
					this.$refs.shp.input.shp_owner_estimate = price_reference
					this.$refs.shp.input.code = code
					this.$refs.shp.input.id = id
					this.$refs.equipments = []
					this.$refs.shp.getDetailMcrItem()
				}else{
					this.$notify({
						message: this.tt("please_complete_data", { title: this.tt("equipment") }),
						type: "danger",
						verticalAlign: "bottom",
						horizontalAlign: "left"
					});
					return;
				}
			},
			closeSHP(){
				this.formShp = false;
			},
			applyVarMcrType(mcrInformation){
				if(this.$refs.FormA1) {
					this.$refs.FormA1.varMcrType = mcrInformation.mcr_type
					this.$refs.FormA1.getDetailMcrItem()
				}
				if(this.$refs.FormB){
					this.$refs.FormB.varMcrType = mcrInformation.mcr_type
					this.$refs.FormB.getDetailMcrItem()
				}

				this.formCode = mcrInformation.type
				// //TypeMcr = consumable || suku_cadang_penyangga || not_applicable
				// if (typeMcr && (this.authUserRole['User Pemeliharaan'] || this.authUserRole['Staff Reliability'] || this.authUserRole['Cataloguer'] )) {					
				// 	//munculin notification
				// 	if (typeMcr === 'consumable') {
				// 		this.$notify({
				// 			message: this.tt('consumable_notification'),                  
				// 			type: 'warning',
				// 			verticalAlign: "bottom",
				// 			horizontalAlign: "left"
				// 		});
				// 	} else {
				// 		this.$notify({
				// 			message: this.tt('suku_cadang_penyangga_and_not_applicable_notification'),                  
				// 			type: 'warning',
				// 			verticalAlign: "bottom",
				// 			horizontalAlign: "left"
				// 		});
				// 	}
				// }
			},
			eqpCodeAndCodeFromShpForm(storedEqpCode, codeFormShp, tabShp) {
				if(this.$refs.statusProcess) {
					if (tabShp === 'reliability') {
						this.$refs.statusProcess.tabReliability = tabShp
						this.$refs.statusProcess.eqpCodeStoredForReliability = storedEqpCode
						this.$refs.statusProcess.codeFormShpForReliability = codeFormShp
					} else if (tabShp === 'cataloguer') {
						this.$refs.statusProcess.tabCataloguer = tabShp
						this.$refs.statusProcess.eqpCodeStoredForCataloguer = storedEqpCode
						this.$refs.statusProcess.codeFormShpForCataloguer = codeFormShp
					}
				}
			}
		}
	};	
</script>

// NOTES
// USER
// A1  = CREATE MATERIAL
// A1S = CREATE MATERIAL WITH SHP
// A2  = CHANGE MATERIAL
// A3  = EXTEND MATERIAL
// A4  = DELETE MATERIAL

// CATALOGUER
// B1  = CREATE & EDIT MASTER
// B2  = CREATE MATERIAL
// B2S = CREATE MATERIAL WITH SHP
// B3  = CHANGE MATERIAL
// B4  = EXTEND MATERIAL
// B5  = DELETE MATERIAL